// Whether this shop can send texts yet. Asked once per page load and shared by
// every screen that offers texting, so Messages, the conversation box, payment
// links and the pickup wizard steer to email or explain, rather than letting
// staff type a message that fails on Send (17 Oct: shops may join the beta with
// texting set up later).
//
// Assumes texting is ready until the server says otherwise, so a shop that has
// it never sees a notice flash while the answer loads.
import { useEffect, useState } from 'react';
import { API, authHeaders } from './helpers';

let pending = null;
let known = null;

function fetchTextingReady() {
  if (known !== null) return Promise.resolve(known);
  if (!pending) {
    pending = fetch(`${API}/api/settings`, { credentials: 'include', headers: authHeaders() })
      .then(r => (r.ok ? r.json() : null))
      .then(s => { known = !(s && s.textingReady === false); return known; })
      .catch(() => { pending = null; return true; });
  }
  return pending;
}

export function useTextingReady() {
  const [ready, setReady] = useState(known === null ? true : known);
  useEffect(() => {
    let live = true;
    fetchTextingReady().then(r => { if (live) setReady(r); });
    return () => { live = false; };
  }, []);
  return ready;
}

export const TEXTING_OFF_TITLE = 'Texting is not switched on for your shop yet';
export const TEXTING_OFF_BODY = 'Until it is, texts cannot be sent from Spinboard. Use email or a call instead. To switch texting on, contact Spinboard.';
